<nuc-tab-bar [tabs]="tabBarItems"
             [(activeTab)]="selectedTab">
</nuc-tab-bar>

<rl-custom-workflow-overview-items-component *ngIf="selectedTab === allItemsTab" [(sliderValue)]="sliderValue">
</rl-custom-workflow-overview-items-component>
<rl-custom-workflow-overview-deleted-items-component *ngIf="selectedTab === deletedItemsTab"></rl-custom-workflow-overview-deleted-items-component>
